export const adaptNPID = (queryData) => {
    const { nutricionParenteralRIByDatosGeneralesId: npidData } = queryData;

    return {
        programaNPID1: {
            idNutricionParenteralIntradialiticaRI: npidData?.nutricionParenteralRI?.idNutricionParenteralIntradialiticaRI,
            idComboRIValorKarnofsky: npidData?.nutricionParenteralRI?.idComboRIValorKarnofsky,
            proteinasTotales: npidData?.nutricionParenteralRI?.proteinasTotales,
            lipidosTotales: npidData?.nutricionParenteralRI?.lipidosTotales,
            caloriasTotales: npidData?.nutricionParenteralRI?.caloriasTotales,
            presenciaEdemas: npidData?.nutricionParenteralRI?.presenciaEdemas,
            laboratorio: npidData?.nutricionParenteralRI?.laboratorio,

            laboratorioAdjunto: {
                contentType: npidData?.laboratorioAdjunto?.contentType,
                archivo: npidData?.laboratorioAdjunto?.archivo,
                extension: npidData?.laboratorioAdjunto?.extension,
                titulo: npidData?.laboratorioAdjunto?.titulo,
            }
        },
        programaNPID2: {
            idNutricionParenteralIntradialiticaRI: npidData?.nutricionParenteralRI?.idNutricionParenteralIntradialiticaRI,
            idComboRIValorFAV: npidData?.nutricionParenteralRI?.idComboRIValorFAV,
            idComboRIValorTipoCateter: npidData?.nutricionParenteralRI?.idComboRIValorTipoCateter,
            fechaColocacion: npidData?.nutricionParenteralRI?.fechaColocacion,
            idComboRIValorUbicacion: npidData?.nutricionParenteralRI?.idComboRIValorUbicacion,
            idComboRIValorNroLumenes: npidData?.nutricionParenteralRI?.idComboRIValorNroLumenes,
            cateterNormal: npidData?.nutricionParenteralRI?.cateterNormal,
            bAPestandar: npidData?.nutricionParenteralRI?.bAPestandar,
            magistral: npidData?.nutricionParenteralRI?.magistral,
            volumenMagistral: npidData?.nutricionParenteralRI?.volumenMagistral,
            idComboRIValorMotivoIndicacionMagistral: npidData?.nutricionParenteralRI?.idComboRIValorMotivoIndicacionMagistral,
            idInsumo: npidData?.indicacionRI?.idInsumo,
            cantidadDiaria: npidData?.indicacionRI?.cantidadDiaria,
            nombreInsumo: npidData?.indicacionRI?.idInsumoNavigation?.descripcion,
            diasConexionSemana: npidData?.diaConexionEstandar,
            diasConexionSemanaMagistral: npidData?.diaConexionMagistral
        },
    }
}